import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SectionAccordionSubsection {
  title: string;
  points: string[];
}

export interface SectionAccordionItem {
  title: string;
  points?: string[];
  sections?: SectionAccordionSubsection[];
}

export interface SectionAccordionData {
  id?: string;
  sectionTitle: string;
  icon: string;
  open?: boolean;
  accordions: SectionAccordionItem[];
}

@Component({
  selector: 'section-accordion',
  templateUrl: './section-accordion.component.html',
  styleUrls: ['./section-accordion.component.scss'],
})
export class SectionAccordionComponent {
  @Input() data: SectionAccordionData | null = null;
  @Input() expandedSectionId: string | null = null;
  @Input() expandedAccordionValue: string | null = null;
  @Output() accordionChange = new EventEmitter<{ sectionId: string; value: string }>();

  get groupValue(): string | undefined {
    const id = this.data?.id;
    if (!id || this.expandedSectionId !== id) return undefined;
    return this.expandedAccordionValue ?? undefined;
  }

  onAccordionChange(event: CustomEvent): void {
    const value = event?.detail?.value as string | undefined;
    if (this.data?.id == null) return;
    this.accordionChange.emit({ sectionId: this.data.id, value: value ?? '' });
  }

  getPointDisplay(point: string): { type: 'qa'; question: string; answer: string } | { type: 'plain'; text: string } {
    if (!point || typeof point !== 'string') return { type: 'plain', text: point || '' };
    if (!point.includes('?')) return { type: 'plain', text: point };
    const idx = point.indexOf('?');
    const question = point.slice(0, idx + 1).trim();
    const answer = point.slice(idx + 1).trim();
    return { type: 'qa', question, answer };
  }
}
